import { axiosApi } from "../../../../../api/dbAxios";

export const fetchPromptLibrary = async () => {
  try {
    const response = await axiosApi.get(`/prompts/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching prompt list:", error);
    return [];
  }
};
